
/*
 * GroupedRadio
 *
 * @version 1.0.0
 * @author Patrizia Petrera
 * @since 04-Jul-2025
*/

import GroupedRadio from './GroupedRadio.jsx'

export default GroupedRadio
